import { render, staticRenderFns } from "./DatepickerOptionalControls.vue?vue&type=template&id=e4c64032"
import script from "./DatepickerOptionalControls.vue?vue&type=script&lang=js"
export * from "./DatepickerOptionalControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports